/* eslint-disable */
import axios from 'axios';
import { createBrowserHistory } from 'history';
import { toast } from 'react-toastify';

const history = createBrowserHistory();
const apiRoot = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
  baseURL: apiRoot,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request Interceptor
axiosInstance.interceptors.request.use((request) => {
  request.headers['Platform'] = 'Web';

  // Retrieve dummyToken and userId directly from localStorage
  // const dummyToken = localStorage.getItem("dummyToken");
  // const userId = localStorage.getItem("userId");

  // if (dummyToken) {
  //   request.headers['Authorization'] = `Bearer ${dummyToken}`;
  // }
  // if (userId) {
  //   request.headers['User-ID'] = userId; // Optional, based on your API requirements
  // }

  const accessToken = localStorage.getItem("accessToken");
  const adminId = localStorage.getItem("adminId");

  if (accessToken) {
    request.headers['Authorization'] = `Bearer ${accessToken}`;
  }
  if (adminId) {
    request.headers['Admin-ID'] = adminId; // Optional, based on your API requirements
  }

  return request;
}, error => Promise.reject(error));

// Response Interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.data?.message === 'ReLogin') {
      localStorage.clear();
      history.pushState({}, '', '/Login');
      window.location.href = '#logout';
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response, 
  (error) => {
    const { response } = error || {};

    if (response?.status === 401) {
      // If the error message explicitly mentions token expiry
      if (response?.data?.message === "Token Expired" || response?.data?.message === "Unauthorized") {
        
        // Clear all stored data
        localStorage.clear();

        // Redirect to login page
        window.location.href = "/login";
      }
    }
    
    return Promise.reject(error);
  }
);

// Error Handling
const errorHandler = (error) => {
  const { response } = error || {};
  if (!response) {
    toast.error('Network Issue or Server Down', { autoClose: 3000 });
  } else if (response.status === 401) {
    toast.error('Token has expired. Please login.', { autoClose: 3000 });
  } else if (response.data?.statusCode === 400 && response.data?.message?.message) {
    toast.error(response.data.message.message.join('\n'), { autoClose: 3000 });
  }
};

// Generic Request Function
const request = async (method, path, model = null, customConfig = {}) => {
  try {
    const response = await axiosInstance({ method, url: path, data: model, ...customConfig });
    return response;
  } catch (error) {
    errorHandler(error);
    return Promise.reject(error);
  }
};

// API Methods
export const get = (path, model) => request('get', path, model);
export const post = (path, model) => request('post', path, model);
export const postZip = (path, model) => request('post', path, model, { 
  responseType: 'blob', 
  headers: { 'Accept': 'application/zip' }
});
export const put = (path, model) => request('put', path, model);
export const patch = (path, model) => request('patch', path, model);
export const remove = (path, model) => request('delete', path, model);

export const apiUrl = apiRoot;
